module.exports = __webpack_public_path__ + "img/world-light.87eeca45.png";